import React, { useState, useContext, useEffect } from 'react';
import Button from '../../NecttosComp/Button/Button';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Input2 from '../../NecttosComp/Input/Input2';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { Table, Tbody, Td, Th, Thead, Tr, useSortableData } from '../../NecttosComp/Table/Table';
import toast from 'react-hot-toast';
import Input from '../../NecttosComp/Input/Input';
import Instruction from '../../Documentation/Instruction';

interface College {
	_id: string;
	collegeName: string;
}

interface BugHandlerProps {
	onClose: () => void;
}

const BugHandler = ({ onClose }: BugHandlerProps) => {
	const [formData, setFormData] = useState({
		userId: '',
		collegeName: '',
		collegeId: '',
		userName: '',
		phoneNumber: '',
		deviceType: '',
		issueTitle: '',
		issueDescription: '',
		issueRaisedBy: '',
		issueAllottedTo: '',
		feature: '',
		status: '',
		note: '',
	});

	const [showForm, setShowForm] = useState(false);
	const [submittedData, setSubmittedData] = useState<any[]>([]);
	const [selectedBug, setSelectedBug] = useState<any | null>(null);
	const [selectedUser, setSelectedUser] = useState<any | null>({});
	const [approvedColleges, setApprovedColleges] = useState<College[]>([]);
	const [users, setUsers] = useState<any[]>([]);
	const [staff, setStaff] = useState<any[]>([]);
	const [note, setNote] = useState('');
	const [isEditing, setIsEditing] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');

	const { collegeList } = useContext(FirebaseContext);

	useEffect(() => {
		const fetchApprovedColleges = async () => {
			try {
				const instance = await getAxiosTokenInstance();
				const response = await instance.get('/college/office/register/approved');
				setApprovedColleges(response.data.approvedColleges);
			} catch (error) {
				console.error('Error fetching approved colleges:', error);
			}
		};
		fetchApprovedColleges();
	}, []);

	const getAllBugs = async () => {
		try {
			const instance = await getAxiosTokenInstance();
			const response = await instance.get('/college/office/getAllBugs');
			setSubmittedData(response.data.bugs);
		} catch (error) {
			console.error('Error fetching bugs:', error);
		}
	};

	useEffect(() => {
		getAllBugs();
	}, []);
	console.log(formData);

	useEffect(() => {
		if (formData.collegeId) {
			getUserNameByPhone(formData.phoneNumber);
		}
	}, [formData.collegeId, formData.phoneNumber]);

	const getUserNameByPhone = async (phoneNumber: string) => {
		try {
			const instance = await getAxiosTokenInstance();
			const response = await instance.get(`/college/office/getUserByN?search=${phoneNumber}&collegeId=${formData.collegeId}`);

			setUsers(response.data.users);
		} catch (error) {
			console.error('Error fetching staffs:', error);
		}
	};

	useEffect(() => {
		fetchUsersByCollege(formData.collegeId);
	}, [formData.collegeId]);

	const fetchUsersByCollege = async (collegeId: string) => {
		try {
			const instance = await getAxiosTokenInstance();
			const response = await instance.get(`/college/office/getNamesByCollegeId?collegeId=COL-23D0120D7F2F-4BC1-91F8-D46B399136E3`);
			console.log('Users fetched:', response.data.users);
			setStaff(response.data.users);
		} catch (error) {
			console.error('Error fetching users by college:', error);
		}
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		try {
			if (isEditing && selectedBug) {
				const updatedBug = { ...selectedBug, ...formData, note, bugId: selectedBug._id };
				const instance = await getAxiosTokenInstance();
				const response = await instance.put(`/college/office/updateBug/${selectedBug._id}`, updatedBug);

				if (response.data) {
					await getAllBugs();
					setIsEditing(false);
					setSelectedBug(updatedBug);
					setShowForm(false);
					toast.success('Bug updated successfully!');
					getAllBugs();
				} else {
					toast.error('Failed to update bug');
				}
			} else {
				const response = await (await getAxiosTokenInstance()).post('/college/office/bugportal', formData);
				if (response.data.message === 'Bug report added successfully!') {
					setShowForm(false);
					setFormData({
						userId: '',
						collegeName: '',
						collegeId: '',
						userName: '',
						phoneNumber: '',
						deviceType: '',
						issueTitle: '',
						issueDescription: '',
						issueRaisedBy: '',
						issueAllottedTo: '',
						feature: '',
						status: '',
						note: '',
					});
					toast.success('Bug report added successfully!');
					getAllBugs();
				} else {
					toast.error('Failed to add the bug report');
				}
			}
		} catch (error) {
			console.error('Error submitting bug report', error);
			toast.error('Error submitting bug report');
		}
	};

	const handleRowClick = (bug: any) => {
		setSelectedBug(bug);
		setNote(bug?.note || '');
		setIsEditing(false);
	};

	const handleCloseModal = () => {
		setSelectedBug(null);
		setIsEditing(false);
	};

	const handleuser = (user: any) => {
		setSelectedUser(user);
		setFormData({ ...formData, userName: user.name, phoneNumber: user.phoneNumber, userId: user._id });
		setUsers([]);
	};

	const handleNoteChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		setNote(e.target.value);
	};

	const handleEditClick = () => {
		setIsEditing(true);
	};
	const handleSaveChanges = async () => {
		if (selectedBug) {
			try {
				const updatedBug = { ...selectedBug, note: note, bugId: selectedBug._id, status: formData.status };
				const instance = await getAxiosTokenInstance();
				const response = await instance.put(`/college/office/updateBug/${selectedBug._id}`, updatedBug);

				if (response.data) {
					await getAllBugs();
					setSelectedBug(updatedBug);
					setIsEditing(true);
					toast.success('Bug updated successfully!');

					await getAllBugs();
					setSelectedBug(null);
				} else {
					toast.error('Failed to update bug');
				}
			} catch (error) {
				console.error('Error updating bug', error);
				toast.error('Error updating bug');
			}
		}
	};

	const handleAddButtonClick = () => {
		setShowForm(true);
	};

	const handleBackToListClick = () => {
		setShowForm(false);
	};
	const filteredData = submittedData.filter((bug) => {
		const term = searchTerm.toLowerCase();
		return bug?.userName?.toLowerCase().includes(term) || bug?.phoneNumber?.toLowerCase().includes(term) || bug?.collegeName?.toLowerCase().includes(term) || bug?.issueRaisedByName?.toLowerCase().includes(term) || bug?.status?.toLowerCase().includes(term);
	});
	const { tableItems, requestSort, getIcon } = useSortableData (filteredData || []);

	return (
		<Main title='Bug Register Form' width='100%' height='100%'>
			<Header>
				<div className='flex gap-4 items-center'>
					<Button type='save' onClick={handleAddButtonClick}>
						Add
					</Button>
					<Input2 type='text' fieldName='Search' className='w-[300px] h-[40px] border-0' state={searchTerm} setState={setSearchTerm} />
				</div>
				<div className='flex gap-2'>
					<Button type='print'>Print</Button>
					<Button type='excel'>Excel</Button>
					<Instruction keyId={'bugHandler'}/>
					<Button type='close' onClick={onClose}>
						Close
					</Button>
				</div>
			</Header>
			<Body>
				{showForm ? (
					<form onSubmit={handleSubmit}>
						<div className='flex justify-center items-center h-full'>
							<div className='w-[75%] p-8 bg-slate-100 dark:bg-neutral-800 dark:text-white rounded-xl shadow-lg mt-4'>
								<h2 className='text-2xl dark:text-white font-bold mb-4'>Submit Bug Report</h2>

								<div className='grid grid-cols-3 gap-4 mb-4'>
									<Input width='100%' type='drop' options={approvedColleges || []} fieldName='College Name' optionDisplay='collegeName' optionKey='_id' returnKey='collegeId' didntShowKey state={formData} setState={setFormData} />

									<Input2 className='w-full h-fit' fieldName='Name & Phone Number' returnKey='userId' state={formData} setState={setFormData} options={users} optionKey='_id' optionDisplay='displayName' didntShowKey type='drop' />

									<Input2 width='400px' className='w-full' inputValue={formData.deviceType} returnKey='deviceType' fieldName='device Type' type='drop' options={['Web', 'iOS', 'Android']} state={formData} setState={setFormData} />

									<Input2 width='400px' className='w-full' inputValue={formData.feature} returnKey='feature' fieldName='feature' type='drop' options={['Login', 'Admission', 'Profile', 'Attendance', 'Internal Assessment', 'IQAC', 'NAAC', 'Fees', 'Transfer Certificate', 'None of the Above']} state={formData} setState={setFormData} />

									<Input2 className='w-full' inputValue={formData.issueTitle} returnKey='issueTitle' required fieldName='Issue Title' type='text' state={formData} setState={setFormData} />

									<Input2 className='w-full' inputValue={formData.issueDescription} returnKey='issueDescription' fieldName='Issue Description' type='text' state={formData} setState={setFormData} required />

									<Input width='100%' type='drop' options={staff || []} fieldName='Issue Raised By' optionDisplay='name' optionKey='_id' returnKey='issueRaisedBy' didntShowKey state={formData} setState={setFormData} />

									<Input width='100%' type='drop' options={staff || []} fieldName='Issue Allotted To' optionDisplay='name' optionKey='_id' returnKey='issueAllottedTo' didntShowKey state={formData} setState={setFormData} />

									<Input2 className='w-full' inputValue={formData.status} returnKey='status' fieldName='status' type='drop' options={['Issue Pending', 'Working on it', 'Complete', 'Difficulty to solve']} state={formData} setState={setFormData} />
								</div>

								<div className='flex justify-end mt-4'>
									<Button type='close' onClick={handleBackToListClick}>
										Back to List
									</Button>
									<Button type='submit'>Submit</Button>
								</div>
							</div>
						</div>
					</form>
				) : (
					<div className='mt-6'>
						<h3 className='text-lg font-semibold dark:text-white'>Submitted Bug Reports</h3>
						<Table width='100%' innerWidth={['3%', '18%', '15%', '10%', '10%', '13%', '10%', '10%', '10%']}>
							<Thead>
								<Tr>
									<Th position={0}> Sl.No.</Th>
									<Th position={1} onClick={() => requestSort('collegeName')} icon={getIcon('collegeName')}>College Name</Th>
									<Th position={2} onClick={() => requestSort('userName')} icon={getIcon('userName')}>User Name</Th>
									<Th position={3} onClick={() => requestSort('phoneNumber')} icon={getIcon('phoneNumber')}> Phone Number</Th>
									<Th position={4} onClick={() => requestSort('feature')} icon={getIcon('feature')}> Feature</Th>
									<Th position={5} onClick={() => requestSort('issueTitle')} icon={getIcon('issueTitle')}>Issue Title</Th>
									<Th position={6} onClick={() => requestSort('issueRaisedByName')} icon={getIcon('issueRaisedByName')}>Issue Raised By</Th>
									<Th position={7} onClick={() => requestSort('issueAllottedToName')} icon={getIcon('issueAllottedToName')}>Issue Allotted to</Th>
									<Th position={8} onClick={() => requestSort('status')} icon={getIcon('status')}>Status</Th>
								</Tr>
							</Thead>
							<Tbody height='auto'>
								{tableItems.map((data, i) => (
									<Tr key={i} onClick={() => handleRowClick(data)}>
										<Td index={i} position={0}>
											{i + 1}
										</Td>
										<Td index={i} position={1}>
											{data.collegeName}
										</Td>

										<Td index={i} position={2}>
											{data.userName}
										</Td>
										<Td index={i} position={3}>
											{data.phoneNumber}
										</Td>
										<Td index={i} position={4}>
											{data.feature}	
										</Td>
										<Td index={i} position={5}>
											{data.issueTitle}
										</Td>
										<Td index={i} position={6}>
											{data.issueRaisedByName}
										</Td>
										<Td index={i} position={7}>
											{data.issueAllottedToName}
										</Td>
										<Td index={i} position={8}>
											{data.status}
										</Td>
									</Tr>
								))}
							</Tbody>
						</Table>
					</div>
				)}
				{selectedBug && (
					<div className='fixed inset-0 z-50 bg-gray-900 bg-opacity-[70%] flex items-center justify-center'>
						<div className='bg-slate-100 dark:bg-neutral-800 dark:text-white p-6 rounded-xl shadow-xl w-3/4 max-w-4xl'>
							<h2 className='text-2xl font-semibold  dark:text-white mb-6 text-center'>{isEditing ? 'Edit Bug Report' : 'Bug Report Details'}</h2>

							<div className='space-y-4'>
								<div className='flex justify-between'>
									<p className='font-medium text-gray-700 dark:text-white w-1/3'>
										<strong>College Name:</strong>
									</p>
									<p className='text-gray-700 dark:text-white w-2/3'>{selectedBug.collegeName}</p>
								</div>

								<div className='flex justify-between'>
									<p className='font-medium text-gray-700 dark:text-white w-1/3'>
										<strong>User Name:</strong>
									</p>
									<p className='text-gray-700 dark:text-white w-2/3'>{selectedBug.userName}</p>
								</div>

								<div className='flex justify-between'>
									<p className='font-medium text-gray-700 dark:text-white w-1/3'>
										<strong>Phone Number:</strong>
									</p>
									<p className='text-gray-700 dark:text-white w-2/3'>{selectedBug.phoneNumber}</p>
								</div>
								<div className='flex justify-between'>
									<p className='font-medium text-gray-700 dark:text-white w-1/3'>
										<strong>Device Type:</strong>
									</p>
									<p className='text-gray-700 dark:text-white w-2/3'>{selectedBug.deviceType}</p>
								</div>
								<div className='flex justify-between'>
									<p className='font-medium text-gray-700 dark:text-white w-1/3'>
										<strong>Feature:</strong>
									</p>
									<p className='text-gray-700 dark:text-white w-2/3'>{selectedBug.feature}</p>
								</div>
								<div className='flex justify-between'>
									<p className='font-medium text-gray-700 dark:text-white w-1/3'>
										<strong>Issue Title:</strong>
									</p>
									<p className='text-gray-700 dark:text-white w-2/3'>{selectedBug.issueTitle}</p>
								</div>

								<div className='flex justify-between'>
									<p className='font-medium text-gray-700 dark:text-white w-1/3'>
										<strong>Issue Description:</strong>
									</p>
									<p className='text-gray-700 dark:text-white w-2/3'>{selectedBug.issueDescription}</p>
								</div>

								<div className='flex justify-between'>
									<p className='font-medium text-gray-700 dark:text-white w-1/3'>
										<strong>Issue Raised By:</strong>
									</p>
									<p className='text-gray-700 dark:text-white w-2/3'>{selectedBug.issueRaisedByName}</p>
								</div>

								<div className='flex justify-between'>
									<p className='font-medium text-gray-700 dark:text-white w-1/3'>
										<strong>Issue Allotted To:</strong>
									</p>
										<p className='text-gray-600 w-2/3'>{selectedBug.issueAllottedToName}</p>
								</div>

								<div>
									<p className='font-medium text-gray-700 dark:text-white w-1/3'>
										<strong>Status:</strong>
									</p>
									{isEditing ? <Input2 className='mb-9 start-64 text-gray-700 dark:text-white w-1/3 ' inputValue={formData.status} returnKey='status' fieldName='status' type='drop' options={['Issue Pending', 'Working on it', 'Complete', 'Difficulty to solve']} state={formData} setState={setFormData} /> : <p className='ml-72 text-gray-700 dark:text-white w-2/3 '>{selectedBug.status}</p>}
								</div>
								<div className='flex justify-between'>
									<p className='font-medium text-gray-700 dark:text-white w-1/3'>
										<strong>Note:</strong>
									</p>
									{isEditing ? <textarea className='bg-slate-100 dark:bg-neutral-800 dark:text-white w-2/3' value={note} onChange={handleNoteChange} /> : <p className='text-gray-700 dark:text-white w-2/3'>{selectedBug.note}</p>}
								</div>
							</div>

							<div className='mt-4 flex justify-between'>
								<Button type='close' onClick={handleCloseModal}>
									Close
								</Button>
								{isEditing ? (
									<Button type='submit' onClick={handleSaveChanges}>
										Save
									</Button>
								) : (
									<Button type='edit' onClick={handleEditClick}>
										Edit
									</Button>
								)}
							</div>
						</div>
					</div>
				)}
			</Body>
		</Main>
	);
};

export default BugHandler;
